import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { Booking } from '../booking';

@Component({
  selector: 'app-edit-booking-detail-etc',
  templateUrl: './edit-booking-detail-etc.component.html',
  styleUrls: ['./edit-booking-detail-etc.component.css']
})
export class EditBookingDetailEtcComponent implements OnInit {

  booking!: Booking;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService
  ) {

   }

  ngOnInit() {
    let uuid = this.route.snapshot.paramMap.get("uuid")!;
    this.httpService.getBookingByUuid(uuid).subscribe(booking => {
      this.booking = booking;
    });
  }

}
